import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import {useState} from "react";
import Select from "./Components/Select"
import PatternSelect from "./Components/PatternSelect";
import BugKDSelect from "./Components/BugKDSelect";
import Industry from "./Components/Industry";
import html2canvas from 'html2canvas';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import useMediaQuery from '@mui/material/useMediaQuery';
import Summary from './summary.json'
import './App.css';
const stocks = require('./stocks.json');

const theme = createTheme({
    palette: {
        mode: 'dark',
        background: {
            default: '#080d14',
            paper: '#111a24',
        },
        primary: {
            main: '#5eead4',
        },
        secondary: {
            main: '#f97316',
        },
        divider: 'rgba(148, 163, 184, 0.16)',
        text: {
            primary: '#e5edf5',
            secondary: '#91a3b7',
        },
    },
    shape: {
        borderRadius: 8,
    },
    typography: {
        fontFamily: [
            'Inter',
            '-apple-system',
            'BlinkMacSystemFont',
            'Segoe UI',
            'Roboto',
            'Helvetica Neue',
            'Arial',
            'sans-serif',
        ].join(','),
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    border: '1px solid rgba(148, 163, 184, 0.14)',
                    boxShadow: '0 18px 45px rgba(0, 0, 0, 0.22)',
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    minHeight: 48,
                    fontWeight: 700,
                },
            },
        },
    },
});

function TabContainer(props) {
    const { children, value, index, ...other } = props;


    return (

        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box className="tab-content" sx={{ p: { xs: 1.5, md: 2.5 } }}>
                    {children}
                </Box>
            )}
        </div>
    );
}


function App() {
    const [value, setValue] = useState(0);
    const [date, setDate] = useState(moment());
    const isMobile = useMediaQuery('(max-width:768px)');
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const [stock, selectedStock] = useState(null);
    const handleScreenshot = async () => {
        const canvas = await html2canvas(document.body, {
            useCORS: true,
            scale: 2, // 提高清晰度
            logging: false,
        });

        const imgData = canvas.toDataURL('image/png');

        // 创建下载链接并触发
        const link = document.createElement('a');
        link.href = imgData;
        link.download = `screenshot-${Date.now()}.png`;
        link.click();
    };
    const switchCode = (code) =>{
        if(code >= "600000"){
            if(code[0] === "8"){
                return code + ".BJ";
            }
            return code + ".SH";
        } else if(code[0] === "4"){
            return code + ".BJ";
        } else {
            return code + ".SZ";
        }
    }
    const renderSummary = () => {
        if(!stock){
            return null;
        }
        var summary = Summary[switchCode(stock)];
        if(summary){
            return <div className="summary-card">
                <div className="summary-title">个股摘要</div>
                <div className="summary-tags">
                    {summary.tagList.filter(c=>c["类型"] !== "短期趋势" && c["类型"] !== "短期资金" && c["类型"] !== "舆情分析").map(tag => {
                        return <div key={tag["看点"]} className={tag["影响"] === "利好"? "summary-tag positive": "summary-tag negative"}>{tag["看点"]}</div>
                    })}
                </div>
                <div className="summary-info" dangerouslySetInnerHTML={{__html: summary.info}}>
                </div>

            </div>
        }
        return null;
  }
  return (
      <ThemeProvider theme={theme}>
          <CssBaseline />
      <div className="app-shell">
        <Box className="workspace" sx={{ flex: 1, minWidth: 0 }}>
          {/*<LocalizationProvider dateAdapter={AdapterDateFns}>*/}
          {/*    <DatePicker*/}
          {/*        label="选择交易日"*/}
          {/*        value={date}*/}

          {/*        onChange={(newValue) => setDate(newValue)}*/}
          {/*    />*/}
          {/*</LocalizationProvider>*/}
        <Box className="topbar">
          <div className="brand-block">
              <div className="brand-title">StockUtils</div>
              <div className="brand-subtitle">强势股研究台</div>
          </div>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className="main-tabs">
              <Tab label="强势选股" />
              {/*<Tab label="形态选股"/>*/}
              {/*<Tab label="普通选股"/>*/}
              {/*<Tab label="板块数据"/>*/}
            {/*<Tab label="量化操控" />*/}
          </Tabs>
            <button
                onClick={handleScreenshot}
                className="screenshot-button"
            >
                截图保存
            </button>
            {/*<button*/}
            {/*    onClick={async()=>{*/}
            {/*        await axios.get("https://1251002098-dr6yq3d84c.ap-beijing.tencentscf.com/api/akshare/stock_zh_a_spot_em?r=" + new Date().getTime());*/}
            {/*        await axios.get("https://1251002098-dr6yq3d84c.ap-beijing.tencentscf.com/api/akshare/industry?r=" + new Date().getTime());*/}
            {/*        window.location.reload()*/}
            {/*    }}*/}
            {/*    style={{*/}
            {/*        position: 'fixed',*/}
            {/*        bottom: '60px',*/}
            {/*        right: '20px',*/}
            {/*        zIndex: 9999,*/}
            {/*        padding: '8px 16px',*/}
            {/*        background: '#333',*/}
            {/*        color: '#fff',*/}
            {/*        border: 'none',*/}
            {/*        borderRadius: '8px',*/}
            {/*        cursor: 'pointer'*/}
            {/*    }}*/}
            {/*>*/}
            {/*    数据刷新*/}
            {/*</button>*/}

        </Box>
        {/*<TabContainer value={value} index={10}>*/}
        {/*  <Quant stocks={stocks}></Quant>*/}
        {/*</TabContainer>*/}
          <TabContainer value={value} index={0}>
              <BugKDSelect setSelectedStock={(stock)=>{selectedStock(stock);}} stocks={stocks} date={date}></BugKDSelect>
          </TabContainer>
          <TabContainer value={value} index={1}>
            <PatternSelect  stocks={stocks}></PatternSelect>
          </TabContainer>
        <TabContainer value={value} index={2}>
            <Select stocks={stocks}></Select>
        </TabContainer>
          <TabContainer value={value} index={3}>
              <Industry stocks={stocks}></Industry>
          </TabContainer>
      </Box>
          {!isMobile && (
              <Box className="side-panel" sx={{ flex: '0 0 auto' }}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DateCalendar value={date} onChange={
                          (newValue) => {
                          setDate(newValue);
                            }

                      } />
                  </LocalizationProvider>
                  {renderSummary()}
              </Box>
          )}
      </div>
      </ThemeProvider>
  );
}

export default App;
